<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="dataToShow"
        :fields="fields"
        name="citas.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-card>
      <v-card-title>
        Citas
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex mr-3 xs3>
            <v-select
              clearable
              :items="quotesFilter"
              v-model="quotesFilterValue"
              label="Filtrar por cita"
              item-text="description"
              item-value="id"
            ></v-select>
          </v-flex>
          <v-flex xs3>
            <v-select
              clearable
              :items="responsibleFilter"
              v-model="responsibleFilterValue"
              label="Filtrar por Responsables"
              item-text="user.name"
              item-value="id"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="dataToShow"
        :search="search"
        :loading="loading"
        disable-initial-sort
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.ApellidosFamilia }}</td>
          <td class="text-xs-center">{{ props.item.Email }}</td>
          <td class="text-xs-center">{{ props.item.fechaInicial }}</td>
          <td class="text-xs-center">{{ props.item.HoraInicial }}</td>
          <td class="text-xs-center">{{ props.item.HoraFinal }}</td>
          <td class="text-xs-center">{{ props.item.NombreAsesor }}</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'quote-report-view',
    components: {
      'download-excel': JsonExcel,
    },
    data() {
      return {
        headers: [
          { text: 'Familia', align: 'center', value: 'ApellidosFamilia' },
          { text: 'Email', align: 'center', value: 'Email' },
          { text: 'Fecha', align: 'center', value: 'fechaInicial' },
          { text: 'Hora inicio', align: 'center', value: 'HoraInicial' },
          { text: 'Hora fin', align: 'center', value: 'HoraFinal' },
          { text: 'Nombre asesor', align: 'center', value: 'NombreAsesor' },
        ],
        quotes: [],
        loading: false,
        search: '',
        fields: {
          'Familia': 'ApellidosFamilia',
          'Email': 'Email',
          'Fecha': 'fechaInicial',
          'Hora inicio': 'HoraInicial',
          'Hora fin': 'HoraFinal',
          'Nombre asesor': 'NombreAsesor',
        },
        responsibleFilter: [],
        quotesFilter: [],
        quotesFilterValue: '',
        responsibleFilterValue: '',
      }
    },
    computed: {
      dataToShow() {
        const quotesFilterValue = this.quotesFilterValue
        const responsibleFilterValue = this.responsibleFilterValue

        let filteredData = this.quotes
          .filter(data => {
            if (!quotesFilterValue || quotesFilterValue == '') {
              return true
            }
            return data.quote_id == quotesFilterValue
          })
          .filter(data => {
            if (!responsibleFilterValue || responsibleFilterValue == '') {
              return true
            }
            return data.responsible_id == responsibleFilterValue
          })

        return filteredData
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/quotes/report')
          .then(resp => {
            if (resp.status === 200) {
              this.quotes = resp.data.quotes.sort((a, b) => a.schedule_start_date - b.schedule_start_date)
              this.responsibleFilter = resp.data.responsibles
              this.quotesFilter = resp.data.quotesFilter
            }
          })
          .catch(error => console.log(error))
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/quotes/report.vue